var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn btn-outline-primary font-weight-bold btn-sm mr-2 Mybtn1-primary Mybtn-size1",on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("Clickme")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }